<div class="row">
  <div class="box">
    <div class="box-header">
      <div class="row">
        <div class="col-md-11">
          <h4 class="box-title">Importação de arquivos para SVA. </h4>
        </div>
      </div>
    </div>
    <div class="box-body table-responsive">
      <div class="row">
        <div class="col-md-4">
          <input type="file" class="form-control" (change)="onFileSelected($event)">
        </div>
        <div class="col-md-2 text-center">
          <button (click)="uploadFile()" class="btn btn-primary" [disabled]="!selectedFile">Upload</button>
        </div>
        <div class="col-md-12 mt-4">
          <div *ngIf="filesList.length">
            <h5>Arquivo Processado:</h5>
            <table class="table table-bordered table-striped" datatable>
              <thead>
                <tr>
                  <th>#</th>
                  <th>ARQUIVO</th>
                  <th>DT. ENVIO</th>
                  <th>STATUS</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filesList; let index = index">
                  <td>{{ row.idArquivoImportacaoSva }} </td>
                  <td>{{ row.dsNomeArquivo }} </td>
                  <td>{{ row.dtEnvio }} </td>
                  <td>{{ row.dsStatusProcessamento }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>